<div class="griha-project-detail-header__wrapper">
  <div class="project-detail-notification">
    @if (IsEvaluatorsNotAssigned && userRole==='Coordinator' && projectDetails?.submission_status!==variableConstantFile.PROJECT_PENDING_SUBMISSION && (((projectDetails?.coordinator_target_date | dateToRemainingDays)-25)>0)) {
      <div
        class="error-status">Assign Evaluator to the project. Delayed by {{(projectDetails?.coordinator_target_date |
      dateToRemainingDays)-25}} days.</div>
    }
  </div>
  <div class="griha-project-detail-header__wrapper__icons">
    <div class="icons">
      <mat-form-field appearance="outline" class="griha-project-detail-header__wrapper__icons--details">
        <mat-select [(ngModel)]="selectedValue" (selectionChange)="onSelectionChange($event.value)">
          <mat-option value="projectDetail">Project Detail</mat-option>
          <mat-option value="personalDetail">Personal Detail</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="icons">
        @if (userRole!=='Evaluator') {
          <button class="project-detail-header--btn_workshop"
            (click)="onWorkshopSchedule('siteVisit')">
            <div class="project-detail-header--btn_workshop__section">
              <!-- <mat-icon>calendar_month</mat-icon> -->
              <img src="/assets/images/calendar.svg" />
              <span class="project-detail-header--btn_workshop__section---text">Optional Site Visit</span>
            </div>
          </button>
        }
        @if (userRole!=='Evaluator') {
          <button class="project-detail-header--btn_workshop"
            (click)="onWorkshopSchedule('workshop')">
            <div class="project-detail-header--btn_workshop__section">
              <img src="/assets/images/calendar.svg" />
              <span class="project-detail-header--btn_workshop__section---text"> Optional Workshop</span>
            </div>
          </button>
        }
        <!-- Need to added this after testing done-->
        <!-- [disabled]="projectDetails?.submission_status===variableConstantFile.PROJECT_PENDING_SUBMISSION"
        [ngClass]="projectDetails?.submission_status===variableConstantFile.PROJECT_PENDING_SUBMISSION?'project-detail-header--btn_workshop project-detail-header--btn_workshop_disabled':'project-detail-header--btn_workshop'" -->
        @if (userRole!=='Evaluator') {
          <button class="project-detail-header--btn_workshop"
            [disabled]="projectDetails?.submission_status===variableConstantFile.PROJECT_PENDING_SUBMISSION"
            [matTooltip]="projectDetails?.submission_status===variableConstantFile.PROJECT_PENDING_SUBMISSION?'Mandatory Sitevisit can be scheduled once project submitted':''"
            [ngClass]="projectDetails?.submission_status===variableConstantFile.PROJECT_PENDING_SUBMISSION?'project-detail-header--btn_workshop project-detail-header--btn_workshop_disabled':'project-detail-header--btn_workshop'"
            (click)="onWorkshopSchedule('mandatory_siteVisit')">
            <div class="project-detail-header--btn_workshop__section">
              @if (projectDetails?.submission_status!==variableConstantFile.PROJECT_PENDING_SUBMISSION) {
                <img
                  src="/assets/images/calendar.svg" />
              }
              @if (projectDetails?.submission_status===variableConstantFile.PROJECT_PENDING_SUBMISSION) {
                <img
                  src="/assets/images/calendar_grey.svg" />
              }
              <span class="project-detail-header--btn_workshop__section---text">Final Site Visit</span>
            </div>
          </button>
        }
      </div>
    </div>
    <!-- <button (click)="assignUser()" class="griha-project-detail-header__wrapper__icons--assign-user">
    <img src="/assets/images/person_add.svg" />
  </button> -->
  @if ((userRole==='Evaluator' || userRole==='Coordinator') && (projectDetails?.submission_status!==variableConstantFile.PROJECT_STATUS_EVALUATED && projectDetails?.submission_status!==variableConstantFile.PROJECT_STATUS_CERTIFIED)) {
    <div class="project-status-container"
      >
      @if (userRole==='Coordinator') {
        <div class="project-status-items">
          <div class="project-status-items-title"><img src="assets/images/alarm_success.svg"><span
          class="project-status-success">Overall project status : </span></div>
          @if (projectDetails?.submission_status!==variableConstantFile.PROJECT_PENDING_SUBMISSION) {
            <div class="project-status-details"
              >
              @if ((projectDetails?.coordinator_target_date | dateToRemainingDays)>=0) {
                <span
                  >{{projectDetails?.coordinator_target_date
                | dateToRemainingDays | absoluteValue}} days left</span>
              }
              @if ((projectDetails?.coordinator_target_date | dateToRemainingDays)<0) {
                <span
                  >{{projectDetails?.coordinator_target_date
                | dateToRemainingDays | absoluteValue}} days delay</span>
              }
            </div>
          }
          @if (projectDetails?.submission_status===variableConstantFile.PROJECT_PENDING_SUBMISSION) {
            <div class="project-status-details"
              >
              Submission pending
            </div>
          }
        </div>
      }
      <div class="project-status-items">
        <div class="project-status-items-title"><img src="assets/images/alarm_error.svg"><span
        class="project-status-blue">Evaluation status : </span></div>
        @if ((projectDetails?.submission_status===variableConstantFile.PROJECT_SUBMIT_TO_EVALUATOR)) {
          <div class="project-status-details"
            >
            @if (IsEvaluatorsNotAssigned) {
              <span>Not assigned yet</span>
            }
            @if ((projectDetails?.evaluator_target_date | dateToRemainingDays)>=0 && !IsEvaluatorsNotAssigned) {
              <span
                >{{projectDetails?.evaluator_target_date
              | dateToRemainingDays | absoluteValue}} days left</span>
            }
            @if ((projectDetails?.evaluator_target_date | dateToRemainingDays)<0 && !IsEvaluatorsNotAssigned) {
              <span
                >{{projectDetails?.evaluator_target_date
              | dateToRemainingDays | absoluteValue}} days delay</span>
            }
            @if (!IsEvaluatorsNotAssigned && (projectDetails?.submission_status===variableConstantFile.PROJECT_SUBMIT_TO_EVALUATOR)) {
              <img (click)="viewRequest()" src="assets/images/history.svg" alt=""
                >
            }
          </div>
        }
        @if (projectDetails?.submission_status!==variableConstantFile.PROJECT_SUBMIT_TO_EVALUATOR) {
          <div class="project-status-details"
            >
            Submission pending
          </div>
        }
      </div>
    </div>
  }
  @if ((userRole==='Evaluator' || userRole==='Coordinator') && (projectDetails?.submission_status===variableConstantFile.PROJECT_STATUS_EVALUATED || projectDetails?.submission_status===variableConstantFile.PROJECT_STATUS_CERTIFIED)) {
    <div class="project-status-container"
      >
      Project Approved
    </div>
  }
</div>

</div>